import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { MatButtonModule } from '@angular/material/button'
import { MatDialogModule } from '@angular/material/dialog'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { PipesModule } from '@mmx/pipes'
import { TranslateModule } from '@ngx-translate/core'

import { HistoryDialogComponent } from './history-dialog.component'

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatDialogModule,
    MatExpansionModule,
    MatProgressBarModule,
    MatButtonModule,
    PipesModule,
    TranslateModule,
  ],
  declarations: [
    HistoryDialogComponent,
  ],
  exports: [
    HistoryDialogComponent,
  ],
})
export class HistoryDialogModule {}
